<template>
  <div class="switch" @click="onChange">
    <input type="checkbox" :checked="value" disabled />
    <div class="slider round">
      <div class="circle"></div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'Switcher',
    props: {
      value: {
        type: Boolean,
        default: false,
      },
    },
    methods: {
      onChange() {
        this.$emit('change', !this.value);
      },
    },
  };
</script>
<style lang="scss" scoped>
  .switch {
    position: relative;
    display: inline-block;
    width: 60px;
    height: 34px;
  }

  .switch input {
    display: none;
  }

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    display: flex;
    align-items: center;
    border-radius: 34px;
  }

  .slider .circle {
    position: absolute;
    height: 30px;
    width: 30px;
    left: 1px;
    right: unset;
    background-color: white;
    border-radius: 50%;
  }

  input:checked + .slider {
    background-color: #2196f3;
  }

  input:checked + .slider .circle {
    right: 1px;
    left: unset;
  }
</style>
